import { useContext } from 'react';

import { userContext } from '../contexts';

export const useUserContext = () => useContext(userContext);
